import * as React from 'react';

import classNames from 'classnames';

import 'css!./__styles__/TextBox';

// AI-Generated Documentation - Please Read with Caution

type Props = {
  /**
   * Input type attribute (text, password, email, etc.)
   * @default 'text'
   */
  type?: string;
  /** Placeholder text for the input field */
  placeholder: string;
  /** Callback function triggered when input value changes */
  onUpdateField: $TSFixMe;
  /** Current value of the input field */
  currentValue?: string | number;
  /** Name attribute for the input element */
  name?: string;
  /** Additional CSS class names to apply */
  className?: string;
  /** Optional text label displayed above the input */
  label?: string;
  /** When true, disables the input field
   * @default false
   */
  disabled?: boolean;
  /** Additional props to pass to the input element */
  inputProps?: $TSFixMe;
};

/** A customizable text input component with optional label. */
class TextBox extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
  };

  render() {
    const { placeholder, onUpdateField, currentValue, name, className, label, type, inputProps, disabled } = this.props;
    return (
      <div className={classNames('text-box', className)}>
        {label && <span>{label}</span>}
        <input
          type={type || 'text'}
          className="form-control box"
          placeholder={placeholder}
          onChange={onUpdateField}
          value={currentValue}
          name={name || ''}
          disabled={disabled}
          {...inputProps}
        />
      </div>
    );
  }
}

export default TextBox;
